'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _undoRedoActions = require('../../utils/undoRedo/undoRedoActions');

var _undoRedoSelector = require('../../utils/undoRedo/undoRedoSelector');

var _propsComparisons = require('../../utils/react/propsComparisons');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } // Lib


// Actions


// Selectors


// Prop comparisons


var isNowHovered = (0, _propsComparisons.now)('isHovered');
var isNoLongerHovered = (0, _propsComparisons.noLonger)('isHovered');

var mapStateToProps = function mapStateToProps(state) {
    return {
        isCurrentlyMoving: (0, _undoRedoSelector.getCurrentOperation)(state) === 'move'
    };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        dispatchStartMoveOperation: function dispatchStartMoveOperation() {
            return dispatch((0, _undoRedoActions.startOperation)('move'));
        }
    };
};

exports.default = function (DecoratedComponent) {
    var _dec, _class;

    var NavigateOnHover = (_dec = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps), _dec(_class = function (_React$Component) {
        _inherits(NavigateOnHover, _React$Component);

        function NavigateOnHover(props) {
            _classCallCheck(this, NavigateOnHover);

            var _this = _possibleConstructorReturn(this, (NavigateOnHover.__proto__ || Object.getPrototypeOf(NavigateOnHover)).call(this, props));

            _this.prepareToNavigate = function () {
                _this.setState({ showNavigationFeedback: true });
                _this.hoveredTimerId = setTimeout(_this.hoveredNavigate, 300);
            };

            _this.hoveredNavigate = function () {
                var _this$props = _this.props,
                    element = _this$props.element,
                    dispatchNavigateToBoard = _this$props.dispatchNavigateToBoard,
                    dispatchStartMoveOperation = _this$props.dispatchStartMoveOperation;

                _this.setState({ showNavigationFeedback: false });
                dispatchStartMoveOperation();
                dispatchNavigateToBoard(element.get('id'), true);
            };

            _this.hoveredTimerId = null;

            _this.state = { showNavigationFeedback: false };
            return _this;
        }

        _createClass(NavigateOnHover, [{
            key: 'componentWillReceiveProps',
            value: function componentWillReceiveProps(nextProps) {
                if (isNowHovered(this.props, nextProps) && nextProps.canDrop && nextProps.dropPermitted) {
                    // Delay for longer on the first hover
                    var timeout = this.props.isCurrentlyMoving ? 400 : 700;
                    this.hoveredTimerId = setTimeout(this.prepareToNavigate, timeout);
                }

                if (this.hoveredTimerId && isNoLongerHovered(this.props, nextProps)) {
                    clearTimeout(this.hoveredTimerId);
                    this.setState({ showNavigationFeedback: false });
                }
            }
        }, {
            key: 'render',
            value: function render() {
                var showNavigationFeedback = this.state.showNavigationFeedback;


                return _react2.default.createElement(DecoratedComponent, _extends({}, this.props, { showNavigationFeedback: showNavigationFeedback }));
            }
        }]);

        return NavigateOnHover;
    }(_react2.default.Component)) || _class);


    NavigateOnHover.propTypes = {
        dispatchNavigateToBoard: _propTypes2.default.func,
        dispatchStartMoveOperation: _propTypes2.default.func,
        element: _propTypes2.default.object,
        isCurrentlyMoving: _propTypes2.default.bool
    };

    return NavigateOnHover;
};


//////////////////
// WEBPACK FOOTER
// ./src/client/element/dnd/navigateOnHoverDecorator.js
// module id = 727
// module chunks = 0